module.exports = __webpack_public_path__ + "static/media/right_diagonals.f7098788.svg";